module.exports = __webpack_public_path__ + "img/result-type-wrapper-red.877d3fdc.png";